import Vue from "vue";
import App from "./App.vue";
import "./assets/css/tailwind.css";
import router from "./router";
import store from "./store";
import axios from 'axios'
import VueGtag from "vue-gtag";
import VueCookies from "vue-cookies";
import {CookieStorageManager} from "@/core/Storage/CookieStorageManager";
import {StorageService} from "@/core/Storage/StorageService";
import {axiosInterceptorsAuthHeadersUse, axiosSetDefaultHeaders} from "@/core/AxiosHelper";
import {STORED_TOKEN_KEY_NAME} from "@/utils/constants";

Vue.use(
  VueGtag,
  {
    config: {id: "UA-50109631-2"},
  },
  router,
);

Vue.config.productionTip = false;


Vue.use(VueCookies)
const storageManager = new CookieStorageManager(Vue.$cookies)
const storageService = new StorageService(storageManager)
Vue.prototype.$storageService = storageService
const userRefreshToken = storageService.getItem(STORED_TOKEN_KEY_NAME)
if (userRefreshToken) {
  store.commit('setUserToken', userRefreshToken)
}
axiosSetDefaultHeaders(axios, process.env)
axiosInterceptorsAuthHeadersUse(store, axios, router)

new Vue({
  router,
  store,
  VueCookies,
  render: (h) => h(App),
}).$mount("#webApp");
